import { BestPracticeSvgLogo, Stack, Text } from "@bps/fluent-ui";

import { VERIFY_PIN_FORM_MAX_WIDTH } from "./VerifyPinForm";

export const VerifyPinFormHeader = () => (
  <Stack tokens={{ childrenGap: 8 }}>
    <BestPracticeSvgLogo isBlue width={VERIFY_PIN_FORM_MAX_WIDTH} />
    <Text variant="xLarge">Verify your identity</Text>
  </Stack>
);
